import { render } from "./DownIcon.vue?vue&type=template&id=783acf26&ts=true"
import script from "./DownIcon.vue?vue&type=script&lang=ts"
export * from "./DownIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__